import React, {useState, useCallback} from 'react';
import {
    Card, Button, Thumbnail, Stack, Heading, TextField, Spinner
} from '@shopify/polaris';


import './index.css';

function Accordion({ label, isCollapsed, handleClick, children }: any){
  return (
    <div className="accordion">
      <button className="accordion-button" onClick={handleClick}>
        {label}
      </button>
      <div
        className={`accordion-item ${isCollapsed ? 'collapsed' : 'expanded'}`}
        aria-expanded={!isCollapsed}
      >
        {children}
      </div>
    </div>
  );
}

export default Accordion;